import { Link } from 'react-router-dom';

import { useTranslation } from '../shared/use-translation.js';

export function NotFoundPage(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-4xl font-bold text-foreground">404</h1>
      <p className="mt-2 ibe-muted">{t('notFound.title')}</p>
      <Link to="/" className="ibe-primary-button mt-4">
        {t('notFound.backHome')}
      </Link>
    </div>
  );
}
